import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PsoriasisPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Psoriasis</h1>
        <section className="mb-8">
          <p>Psoriasis is a chronic skin condition that causes red, scaly patches to appear on the skin, often leading to discomfort and self-consciousness. While it is not contagious, psoriasis can affect anyone and may come and go in cycles. The condition is linked to an overactive immune system, which speeds up the growth of skin cells. Living with psoriasis can be challenging, but with the right approach, its symptoms can be managed effectively and naturally.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Genetic predisposition (family history)</li>
            <li>Immune system dysfunction</li>
            <li>Triggers such as stress, skin injuries, or infections</li>
            <li>Certain medications</li>
            <li>Weather changes (especially cold, dry climates)</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Raised, red patches of skin covered with silvery scales</li>
            <li>Dry, cracked skin that may bleed</li>
            <li>Itching, burning, or soreness</li>
            <li>Thickened or ridged nails</li>
            <li>Joint pain or swelling (in some cases)</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>At Shri Varaham Swastik Yoga & Naturopathy Clinic, we believe in treating psoriasis from the inside out. Our herbal philosophy focuses on restoring balance to the body and calming the immune system. We use a combination of time-tested herbs, natural oils, and holistic therapies to soothe the skin, reduce inflammation, and support overall wellness. Each treatment plan is tailored to the individual, ensuring gentle yet effective care without harsh chemicals.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>No harmful side effects</li>
            <li>Addresses root causes, not just symptoms</li>
            <li>Promotes long-term skin health</li>
            <li>Personalized care for every patient</li>
            <li>Supports overall well-being and immunity</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Maintain a balanced, plant-rich diet</li>
            <li>Practice regular yoga and gentle exercise</li>
            <li>Manage stress through meditation or breathing exercises</li>
            <li>Keep skin moisturized with natural oils</li>
            <li>Avoid known triggers such as harsh soaps or extreme temperatures</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment cure psoriasis completely?</strong>
            <p>A: While there is no permanent cure for psoriasis, our herbal approach can significantly reduce symptoms, improve skin health, and help prevent flare-ups.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: How long does it take to see results?</strong>
            <p>A: Many patients notice improvement within a few weeks, but long-term management and consistency are key for lasting benefits.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Is the treatment safe for children and elderly patients?</strong>
            <p>A: Yes, our herbal remedies are gentle and can be adapted for all age groups. We always customize the plan to suit individual needs.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Ready to take control of your skin health? Book a consultation with our experienced team today and discover the benefits of natural, holistic care for psoriasis!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default PsoriasisPage; 